import { MessageCircle, Heart, Coffee, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

const footerItems = [
  {
    icon: MessageCircle,
    label: "Discord",
    description: "Join our community",
    href: "https://discord.gg/gqBgvgGj8H",
    external: true,
  },
  {
    icon: Heart,
    label: "Patreon",
    description: "Support the project",
    href: "https://www.patreon.com/WarYes",
    external: true,
  },
  {
    icon: Coffee,
    label: "Buy me a coffee",
    description: "Show your support",
    href: "https://www.buymeacoffee.com/captaintoucan",
    external: true,
  },
  {
    icon: ShieldCheck,
    label: "Privacy Policy",
    description: "View our policy",
    href: "/privacy-policy",
    external: false,
  },
];

export function Footer() {
  return (
    <footer className="relative z-10 w-full bg-transparent py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {footerItems.map((item) => {
            const Icon = item.icon;
            const cardContent = (
              <Card className="h-full min-h-[80px] transition-all duration-200 hover:shadow-lg hover:shadow-primary/10 hover:border-primary/30 cursor-pointer bg-transparent backdrop-blur-sm border-border/50">
                <CardContent className="flex flex-col items-center justify-center gap-2 p-4 h-full">
                  <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 text-primary group-hover:bg-primary/15 transition-colors shadow-lg shadow-primary/10 flex-shrink-0">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-xs font-medium text-center text-foreground group-hover:text-primary transition-colors">
                    {item.label}
                  </span>
                  <span className="text-xs text-center text-muted-foreground group-hover:text-foreground/80 transition-colors">
                    {item.description}
                  </span>
                </CardContent>
              </Card>
            );

            return item.external ? (
              <a
                key={item.label}
                href={item.href}
                className="group"
              >
                {cardContent}
              </a>
            ) : (
              <Link
                key={item.label}
                to={item.href}
                className="group"
              >
                {cardContent}
              </Link>
            );
          })}
        </div>
      </div>
    </footer>
  );
}
